// extracted by mini-css-extract-plugin
export var page = "page__NIf8L";
export var pageContent = "page-content__oA3Mc";
export var title = "title__LWONU";
export var subtitle = "subtitle__rTeHs";